import firebase from "gatsby-plugin-firebase"

export const GoogleAuthProvider = new firebase.auth.GoogleAuthProvider();

export const FacebookAuthProvider = new firebase.auth.FacebookAuthProvider();